import { useQueryClient, useMutation } from 'react-query';
import { useService } from 'shared/providers';

export function useDeletePdfFile() {
  const { quoteService } = useService();
  const queryClient = useQueryClient();
  const mutation = useMutation<boolean, Error, string>(request => quoteService.deleteQuoteFile(request), {
    onSuccess: () => {
      queryClient.invalidateQueries('files');
    },
    onError: error => {
      console.log('File not deleted ', error);
    },
  });

  return mutation;
}
